export const generateAnimationDelayStyle = (seconds: number) => ({ animationDelay: seconds * 1000 + "ms" });
